import { Component } from '@angular/core';
import { takeUntil } from 'rxjs/operators';

import { NavigationService } from '@common';
import { BaseComponentOnDestroy } from '@common/epics/base-component-on-destroy';
import { PageTitleDetail } from '@common/model';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.less'],
  standalone: false
})
export class BreadcrumbsComponent extends BaseComponentOnDestroy {
  pageTitleDecorators: PageTitleDetail[] = [];

  constructor(private navigationService: NavigationService) {
    super();
    this.initNavigationPageTitleListener();
  }

  initNavigationPageTitleListener() {
    this.navigationService.pageTitleDecoratorsChanged.pipe(
      takeUntil(this.isDestroyed$))
      .subscribe((pageTitleDecorators) => {
        this.pageTitleDecorators = pageTitleDecorators;
      });
  }
}
